module.exports = __webpack_public_path__ + "static/media/parts_03.24153ed1.svg";